import { PromotionStatusEnum } from "./status-enum";

export const promotionStatusColors = Object.freeze({
  [PromotionStatusEnum.DRAFT]: "default",
  [PromotionStatusEnum.ACTIVE]: "success",
  [PromotionStatusEnum.PAUSED]: "warning",
  [PromotionStatusEnum.DEPLETED]: "error",
  [PromotionStatusEnum.EXPIRED]: "error",
});
